import { Component, Input } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-assign-modal",
    templateUrl: "./assign-modal.component.html",
    styleUrls: ["./assign-modal.component.scss"],
})
export class AssignModalComponent {
    @Input() public activityData: any = null

    constructor(public activeModal: ModalRef) {}
}
